export default {
      id: "promote-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#promote",
      toString: function () {
        return this.url;
      }
    }